














































const namespace = 'calendar';
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import SingleActivityBig from '@/modules/calendar/components/locations/SingleActivityBig.vue';
import SingleActivityMobile from '@/modules/calendar/components/locations/SingleActivityMobile.vue';
import SingleActivityNormal from '@/modules/calendar/components/locations/SingleActivityNormal.vue';
import SingleActivitySmall from '@/modules/calendar/components/locations/SingleActivitySmall.vue';
import SingleActivityPopup from '@/modules/calendar/components/locations/SingleActivityPopup.vue';
import MobileSingleActivityPopup from '@/modules/calendar/components/locations/MobileSingleActivityPopup.vue';
import { Action, Getter } from 'vuex-class';
import { Environment } from '@/modules/configuration/store/types';

@Component({
    name: 'SingleActivity',
    components: {
        SingleActivityBig,
        SingleActivityMobile,
        SingleActivityNormal,
        SingleActivitySmall,
        SingleActivityPopup,
        MobileSingleActivityPopup,
    },
})
export default class SingleActivity extends Vue {
    @Prop() public event!: ICalendarData;
    @Prop() private countLocationsAndEvents!: { countLocations: number; countEvents: number };
    @Prop() private boxType!: string;
    @Getter('openedSingleActivityPopups', { namespace }) private openedSingleActivityPopups!: number[];
    @Getter('weekdayContainerWidth', { namespace }) private weekdayContainerWidth!: number;
    @Getter('boxWidth', { namespace }) private boxWidth!: number;
    @Getter('isMobile', { namespace }) private isMobile!: number;
    @Getter('environment', { namespace: 'configuration' }) private environment!: Environment;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('closeAllSingleActivityPopups', { namespace }) private closeAllSingleActivityPopups: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('openSingleActivityPopup', { namespace }) private openEventSingleActivityPopup: any;

    private singleActivityPopupOpen = false;
    private maxEventsForNormalActivity = 14;
    private maxEventsForBigActivity = 4;
    private popupStyleProp = { left: 0, top: 0 };

    private get mobileView() {
        return this.isMobile;
    }

    private get zoukWrocloveMobileView() {
        return this.isMobile && this.environment.name === 'zoukwroclove';
    }

    private get getPopupStyle() {
        return `
        left: ${this.popupStyleProp.left}px;
        top: ${this.popupStyleProp.top}px;
      `;
    }

    private get getWrapperStyle() {
        const maxBoxWidth = 520;
        const calculatedWidth = this.boxWidth;
        const style = 0 < calculatedWidth && calculatedWidth < maxBoxWidth ? `width: ${calculatedWidth}px;` : ``;
        return style;
    }

    private get getEvent() {
        return this.event;
    }

    private get showSingleActivitySmall() {
        return this.boxType === 'small';
    }

    private get showSingleActivityNormal() {
        return this.boxType === 'normal';
    }

    private get showSingleActivityBig() {
        return this.boxType === 'big';
    }

    protected isSingleActivityPopupOpen(event: ICalendarData) {
        return this.openedSingleActivityPopups.includes(event.Id);
    }

    public openPopupFromUrl(event: Event) {
        this.setPopupPosition(event);
    }

    public openSingleActivityPopup(event: Event) {
        this.hideAllRest();
        this.setPopupPosition(event);
        this.openEventSingleActivityPopup(this.event.Id);
    }

    public hideAllRest() {
        this.closeAllSingleActivityPopups();
    }

    public hideSingleActivityPopup() {
        this.closeAllSingleActivityPopups();
    }

    private setPopupPosition(event: Event) {
        const popup = event.target instanceof HTMLElement ? event.target.closest('.js-popup-wrapper') : '';
        if (event.target instanceof HTMLElement && popup) {
            const popupViewportOffset = popup.getBoundingClientRect();
            const { X1, X2, Y1, Y2 } = this.calculateNodePosition(popupViewportOffset);
            this.setPopupPositionX(popup, X1, X2);
            this.setPopupPositionY(popup, Y1, Y2);
        }
    }

    private calculateNodePosition(nodeViewportOffset: { left: number; top: number }) {
        const X1 = nodeViewportOffset.left;
        const X2 = window.innerWidth - X1;
        const Y1 = nodeViewportOffset.top;
        const Y2 = window.innerHeight - Y1;

        return { X1, X2, Y1, Y2 };
    }

    private setPopupPositionY(popup: Element, Y1: number, Y2: number) {
        const popupHeight = 240;
        const totalHeight = -popup.clientHeight - popupHeight;
        this.popupStyleProp.top = Y1 > Y2 || this.isMobile ? totalHeight : popup.clientTop - popup.clientHeight;
    }

    private setPopupPositionX(popup: Element, X1: number, X2: number) {
        const popupWidth = 450;
        const targetWidth = 39;
        const totalWidth = popup.clientWidth - popupWidth - targetWidth;
        this.popupStyleProp.left = X1 > X2 ? totalWidth : popup.clientLeft;
    }
}
